import { render } from "./RelatedResources.vue?vue&type=template&id=116941fa"
import script from "./RelatedResources.vue?vue&type=script&lang=js"
export * from "./RelatedResources.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__